import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Accueil from "./pages/accueil";
import Peinture from "./pages/peinture";
import Digital from "./pages/digital";
import Oeuvres from "./pages/oeuvres";
import ArticleDetailPage from "./pages/oeuvreId";
import APropos from "./pages/aPropos";
import Coments from './component/oeuvreid/coment';
import AppLayout from './component/layout/AppLayout';


const RoutesPage = () => {


    return (
        <Router>
            <AppLayout>
                <Routes>
                    <Route path="/" element={<Accueil />} />
                    <Route path="/peinture" element={<Peinture />} />
                    <Route path="/digital" element={<Digital />} />
                    <Route path="/oeuvres" element={<Oeuvres />} />
                    <Route path="/oeuvre/:id" element={<ArticleDetailPage />} />
                    <Route path="/apropos" element={<APropos />} />
                    <Route path="/articles/:slug/comments" element={<Coments />} />
                </Routes>
            </AppLayout>
        </Router>
    )
}

export default RoutesPage
